import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';

@Component({
  selector: 'gdp-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss']
})
export class ToastsComponent implements OnInit {
  public DEFAULT_DELAY = 30000;
  public copied: boolean = false;
  @ViewChild('t') t: NgbTooltip;

  constructor(
    public notificationService: NotificationService,
    private utils: UtilsService
  ) {}

  ngOnInit() {
  }

  onCopy(toast: string): void {
    let splittedArray = toast.split(/(<b>)|(<br>)|(<\/b>)/);
    splittedArray = splittedArray.filter(
      el => el && (el !== '<b>' && el !== '</b>' && el !== '<br>')
    );
    const message: string = splittedArray.join('');

    this.utils.copyToClipboard(
      message,
      'text/plain',
      () => {
        this.t.open();
        setTimeout(() => this.t.close(), 2000);
      }
    );
  }
}
